export const  weatherName = {
    'дымка': require('@/assets/images/minicloud.svg'),
    'ясно':  require('@/assets/images/sun.svg'),
    'небольшая облачность' :  require('@/assets/images/cloud.svg'),
    'пасмурно': require('@/assets/images/cloud.svg'),
    'облачно с прояснениями' :  require('@/assets/images/sunrain.svg'),
    'небольшой дождь':  require('@/assets/images/minirain.svg'),
    'дождь':  require('@/assets/images/rain.svg'),
    'переменная облачность':  require('@/assets/images/cloud.svg'),
}


